<template>
  <v-expansion-panel>
    <v-expansion-panel-header class="pl-2">
      <v-icon class="flex-grow-0 pr-4">
        alt_route
      </v-icon>
      <span>History Overview</span>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-row
        v-for="(item, index) of summaryItems"
        :key="index"
        class="text-caption"
      >
        <v-col>{{ item.text }}</v-col>
        <v-col>{{ item.value }}</v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { PARTY_NAMESPACE } from '@/store/party'
import { humanize } from '@/utilities/string-utilities'
import { mapGetters } from 'vuex'

export default {
  name: 'HistoryOverviewSummary',

  data () {
    return {
      items: [
        { prop: 'years_education', value: null },
        { prop: 'any_work_history', value: null },
        { prop: 'any_criminal_history', value: null },
        { prop: 'previously_detained', value: null },
        { prop: 'presently_detained', value: null },
      ],
    }
  },

  computed: {
    summaryItems () {
      return this.items.map(item => ({ ...item, text: humanize(item.prop), value: this.peParty[item.prop] }))
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peParty',
    ]),
  },
}
</script>
